import { render } from "./billListDraft.vue?vue&type=template&id=273b593d&scoped=true"
import script from "./billListDraft.vue?vue&type=script&lang=js"
export * from "./billListDraft.vue?vue&type=script&lang=js"

import "./billListDraft.vue?vue&type=style&index=0&id=273b593d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273b593d"]])

export default __exports__